import { useQuery } from '@tanstack/react-query';

import { authenticationAPIService } from '~/api/login';
import { AccountResponse } from '~/types/account';

export default function useCurrentUser({ select }: { select?: (data: AccountResponse) => unknown } = {}) {
  return useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      const response = await authenticationAPIService.getAccount();
      return response.data;
    },
    select,
  });
}
